import { useCookie } from 'next-cookie';
import { requests } from '@/helpers/api';
import { useMutation } from '@/hooks/useQuery';

const useRequestSetting = ({ lang }) => {
  const cookie = useCookie();
  const { mutate: sendSettingRequest, isError, isSuccess, isLoading, reset } = useMutation(requests.sendSettingRequest);

  const onSubmit = async (values) => {
    const formData = new FormData();

    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'object' && Array.isArray(values[key])) {
        Object.keys(values[key]).forEach(i => {
          formData.append(`${key}[${i}]`, values[key][i]);
        });
      } else {
        formData.append(key, values[key]);
      }
    });

    const roistatVisit = cookie.get('roistat_visit');
    const cookieUtm = cookie.get('utm');
    const utm = cookieUtm ? cookieUtm : {};

    let lastIndex = 0;

    Object.entries(utm).forEach(([key, value]) => {
      formData.append(`registerQuery[${lastIndex}][key]`, key);
      formData.append(`registerQuery[${lastIndex}][value]`, value);
      lastIndex += 1;
    });

    formData.append(`registerQuery[${lastIndex}][key]`, 'curpage');
    formData.append(`registerQuery[${lastIndex}][value]`, window.location.origin + window.location.pathname);
    lastIndex += 1;

    if (roistatVisit) {
      formData.append('roistatVisit', roistatVisit);

      if (!utm.roistat_visit) {
        formData.append(`registerQuery[${lastIndex}][key]`, 'roistat_visit');
        formData.append(`registerQuery[${lastIndex}][value]`, roistatVisit);
        lastIndex += 1;
      }
    }

    return sendSettingRequest(formData, lang);
  };

  return { onSubmit, isSuccess, isError, reset, isLoading };
};

export { useRequestSetting };
